import React, {useRef, useState} from "react";
import {Card} from "react-bootstrap";
import AuthService from "../../services/auth.service";
import {useNavigate} from "react-router-dom";
import {Trans, useTranslation} from "react-i18next";
import {BsShieldLock} from "react-icons/bs";
import {LiaToggleOffSolid, LiaToggleOnSolid} from "react-icons/lia";
import {AiOutlineMail} from "react-icons/ai";
import {MdOutlinePhoneAndroid} from "react-icons/md";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import {PiPasswordLight} from "react-icons/pi";
import MessageBox from "../core/MessageBox";
import {EMAIL, focusOn, TOTP} from "../canopia/CanopiaUtils";
import SixDigitCode from "./SixDigitCode";
import {GiPlainCircle} from "react-icons/gi";
import ajaxloader from "../../images/ajax-loader.gif";

export default function Security(props) {
    const {t} = useTranslation();

    const navigate = useNavigate();

    const user = props.user;
    const mfaTypeOrig = user.mfaType;

    // const [useEmail, setUseEmail] = useState(false);
    const [tgtMfa, setTgtMfa] = useState(mfaTypeOrig); // e-mail/totp
    const [mfaCodeValid, setMfaCodeValid] = useState(null); // For TOTP
    const [showValidityIcon, setShowValidityIcon] = useState(false); // For TOTP

    const [loading, setLoading] = useState(false);
    const [qrUrl, setQrUrl] = useState(null);
    const [show2FASetup, setShow2FASetup] = useState(false);
    const [showMessageModal, setShowMessageModal] = useState(false);
    const [errorName, setErrorName] = useState(null);
    const [errorMessage, setErrorMessage] = useState(null);
    const [saveMessage, setSaveMessage] = useState(null);

    const confirmTotpRef = useRef(null);
    const confirmEmailRef = useRef(null);

    const paddingFirst = '1em 0.5em 0.5em 0.5em';
    const padding = '0.5em 0.5em';
    const paddingIcon = '0.25em 0.5em';
    const w1 = '250px';
    const w2 = '200px';
    const w100 = '100%';
    const toggleIconSize = '2.7em';

    function changePwd() {
        navigate("/change-pwd");
    }

    function changeMfa(mfaType) {
        let newMfa;
        switch (mfaType) {
            case EMAIL:
                newMfa = !tgtMfa || tgtMfa === TOTP ? mfaType : null;
                break;
            case TOTP:
                newMfa = !tgtMfa || tgtMfa === EMAIL ? mfaType : null;
                break;
            default:
                console.error('Unknown ' + mfaType);
                return;
        }
        setTgtMfa(newMfa);
    }

    const setupMfa = (mfaType) => {

        changeMfa(mfaType);

        setShow2FASetup(true);
        setQrUrl(null);
        setErrorName(null);
        setErrorMessage(null);
        setSaveMessage(null);

        switch (mfaType) {
            case EMAIL:
                focusOn(confirmEmailRef);
                break;
            case TOTP:
                // Ask to create a secret
                generateQrUrl();
                break;
            default:
                console.error('Unknown ' + mfaType);
                return;
        }
    }

    const saveSecurity = () => {

        setLoading(true);
        setSaveMessage(null);
        setErrorName(null);
        setErrorMessage(null);

        AuthService.saveSecurity(user.username, tgtMfa)
            .then((response) => {
                    setLoading(false);
                    setSaveMessage(response.data);
                    // setShowMessageModal(true);
                    // setShow2FASetup(false);
                    setQrUrl(null);
                },
                error => {
                    setLoading(false);
                    setShowMessageModal(true);
                    setErrorName('Error');
                    setErrorMessage(error.data);
                }
            );
    }

    const changeMfaCode = (code) => {
        setShowValidityIcon(false);
        setMfaCodeValid(false);
    }

    const validateCode = (code) => {
        setLoading(true);
        setMfaCodeValid(false);
        setShowValidityIcon(false);
        AuthService.validateCode(user.username, code)
            .then(() => {
                    setMfaCodeValid(true);
                    focusOn(confirmTotpRef);
                },
                error => {
                    setMfaCodeValid(false);
                    setErrorName('Error');
                    setErrorMessage(error.data);
                }
            );
        setLoading(false);
        setShowValidityIcon(true);
    }

    const generateQrUrl = () => {
        setLoading(true);
        AuthService.generateQrUrl(user.username)
            .then(
                response => {
                    setQrUrl(response.data);
                    setLoading(false);
                },
                error => {
                    const resMessage =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();

                    setErrorName('Error');
                    setErrorMessage(resMessage);
                    setLoading(false);
                }
            );
    }

    const cancel2FASetup = () => {
        setShow2FASetup(false);
        setTgtMfa(mfaTypeOrig);
        setMfaCodeValid(false);
    }

    function hideMessageModal() {
        setShowMessageModal(false);
        setMfaCodeValid(false);
        setSaveMessage(null);
        setErrorName(null);
        setErrorMessage(null);
    }

    function reload() {
        window.location.reload();
    }

    return (
        <div className="main-content">
            <Card className={'canopia-card'} style={{width: '60rem'}}>
                <Card.Body>
                    <Card.Title className='canopia-card-title'>
                        {t('security')} <BsShieldLock color={'#adad2f'} size={'1.4em'}/>
                    </Card.Title>
                    {!show2FASetup && <>
                        <div className={'security-box'} style={{marginTop: '2rem'}}>
                            <div className={'flex-nowrap'} style={{marginTop: '.3rem'}}>
                                <div className={"setup-th"} style={{flexBasis: w100, padding: padding}}>
                                    <Trans i18nKey="level1" components={{p: <p/>, header: <p className="header"/>}}/>
                                </div>
                            </div>

                            <div className={'flex-nowrap'}>
                                <div className={"setup-col"} style={{flexBasis: w1, padding: paddingFirst}}>
                                    <PiPasswordLight color={'#adad2f'} size={'1.8em'}
                                                     style={{marginRight: '.5rem'}}/>{t('pwd')}
                                </div>
                                <div className={"setup-col"} style={{flexBasis: w1, padding: paddingFirst}}>
                                    Last updated: {user.passwordUpdateFmt}
                                </div>
                                <div className={"setup-col"} style={{flexBasis: w2, padding: padding}}>
                                    <Button variant="primary" onClick={() => changePwd()}>
                                        {t('chgPwd')}
                                    </Button>
                                </div>
                            </div>
                        </div>

                        <div className={'security-box'} style={{marginTop: '2rem'}}>
                            <div className={'flex-nowrap'} style={{marginTop: '.3rem'}}>
                                <div className={"setup-th"} style={{flexBasis: w100, padding: padding}}>
                                    <Trans i18nKey="2FA_header" components={{p: <p/>, b: <b/>, header: <p className="header"/>}}/>
                                </div>
                            </div>
                            {mfaTypeOrig ?
                                <div className={'flex-nowrap'}>
                                    <div className={'setup-th'} style={{padding: padding}}>
                                        {t('status')}
                                    </div>
                                    <div className={'setup-th'} style={{padding: padding}}>
                                        <div className={'mfa-enabled nowrap'}>
                                            {t('enabled')}
                                        </div>
                                    </div>
                                </div> :
                                <>
                                    <div className={'flex-nowrap'}>
                                        <div className={'setup-th'} style={{padding: padding}}>
                                            {t('status')}
                                        </div>
                                        <div className={'setup-th'} style={{padding: padding}}>
                                            <div className={'mfa-disabled nowrap'}>
                                                {t('disabled')}
                                            </div>
                                        </div>
                                    </div>
                                    <div className={'flex-nowrap'}>
                                        <div className={"setup-th"} style={{flexBasis: w100, padding: padding}}>
                                            <Trans i18nKey="2FA_disabled_text" components={{p: <p/>, header: <p className="header"/>}}/>
                                        </div>
                                    </div>
                                </>
                            }
                            <div className={'border-top background-light'}
                                 style={{marginTop: '1rem', display: "flex", flexWrap: "nowrap"}}>
                                <div className={"setup-th"} style={{flexBasis: w1, padding: padding}}>
                                    {t('authMethod')}
                                </div>
                                <div className={"setup-th"} style={{flexBasis: w2, padding: padding}}>
                                    {t('security')}
                                </div>
                                <div className={"setup-th"} style={{flexBasis: w1, padding: padding}}>
                                    {t('enable_disable')}
                                </div>
                            </div>
                            <div className={'flex-nowrap'}>
                                <div className={"setup-col"} style={{flexBasis: w1, padding: paddingFirst}}>
                                    <MdOutlinePhoneAndroid color={'#adad2f'} size={'1.8em'}
                                                           style={{marginRight: '.5rem'}}/>{t('totp')}
                                </div>
                                <div className={"setup-col"} style={{flexBasis: w2, padding: paddingFirst}}>
                                    <div className={'nowrap'}>
                                        <GiPlainCircle color={'#59C386'} size={'1.4em'}/>
                                        <GiPlainCircle color={'#59C386'} size={'1.4em'}/>
                                        <GiPlainCircle color={'#59C386'} size={'1.4em'}/>
                                        <GiPlainCircle color={'#59C386'} size={'1.4em'}/>
                                    </div>
                                </div>
                                <div className={"setup-col"} style={{flexBasis: '120px', padding: padding}}>
                                    <span className={'label-hover'} onClick={() => setupMfa(TOTP)}>
                                        {tgtMfa === TOTP ?
                                            <LiaToggleOnSolid color={'#adad2f'} size={toggleIconSize}/> :
                                            <LiaToggleOffSolid color={'#adad2f'} size={toggleIconSize}/>}
                                    </span>
                                </div>
                            </div>
                            <div className={'flex-nowrap'}>
                                <div className={"setup-col"} style={{flexBasis: w1, padding: padding}}>
                                    <AiOutlineMail color={'#adad2f'} size={'1.8em'}
                                                   style={{marginRight: '.5rem'}}/>{t('email')}
                                </div>
                                <div className={"setup-col"} style={{flexBasis: w2, padding: padding}}>
                                    <div className={'nowrap'}>
                                        <GiPlainCircle color={'#59C386'} size={'1.4em'}/>
                                        <GiPlainCircle color={'#59C386'} size={'1.4em'}/>
                                    </div>
                                </div>
                                <div className={"setup-col"} style={{flexBasis: '120px', padding: paddingIcon}}>
                                    <span className={'label-hover'} onClick={() => setupMfa(EMAIL)}>
                                        {tgtMfa === EMAIL ?
                                            <LiaToggleOnSolid color={'#adad2f'} size={toggleIconSize}/> :
                                            <LiaToggleOffSolid color={'#adad2f'} size={toggleIconSize}/>}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </>}

                    {saveMessage ? <>
                            <MessageBox
                                title={'Information'}
                                message={saveMessage}
                                colorClass={'canopia2'}
                            />
                            <Button variant="primary" onClick={() => reload()}>
                                {t('close')}
                            </Button>
                        </>
                        :
                        show2FASetup && <>
                            {!tgtMfa && <>
                                <div className={'flex-nowrap'} style={{marginTop: '1rem'}}>
                                    <div className={"setup-th"} style={{flexBasis: w100, padding: padding}}>
                                        <Trans i18nKey="2FA_setup_disable" components={{p: <p/>, header: <p className="header"/>}}/>
                                    </div>
                                </div>
                                <div className={'flex-nowrap'} style={{marginTop: '1rem'}}>
                                    <div className={"setup-th"} style={{padding: padding}}>
                                        <Button variant="secondary" onClick={() => cancel2FASetup()}>
                                            {t('cancel')}
                                        </Button>
                                    </div>
                                    <div className={"setup-th"} style={{padding: padding}}>
                                        <Button variant="primary" onClick={() => saveSecurity()}>
                                            {t('confirm')}
                                        </Button>
                                    </div>
                                </div>
                            </>
                            }

                            {tgtMfa === EMAIL && <>
                                <div className={'flex-nowrap'} style={{marginTop: '1rem'}}>
                                    <div className={"setup-th"} style={{flexBasis: w100, padding: padding}}>
                                        <AiOutlineMail color={'#adad2f'} size={'1.8em'}
                                                       style={{margin: '0 .5rem .4rem 0'}}/><Trans i18nKey="EMAIL_setup_header" components={{header: <span className="header"/>}}/>
                                    </div>
                                </div>
                                <div className={'flex-nowrap'} style={{marginTop: '1rem'}}>
                                    <div className={"setup-th"} style={{flexBasis: w100, padding: padding}}>
                                        <Trans i18nKey="EMAIL_setup_body" components={{p: <p/>, header: <p className="header"/>}}/>
                                    </div>
                                </div>
                                <div className={'flex-nowrap'} style={{marginTop: '1rem'}}>
                                    <div className={"setup-th"} style={{padding: padding}}>
                                        <Button variant="secondary" onClick={() => cancel2FASetup()}>
                                            {t('cancel')}
                                        </Button>
                                    </div>
                                    <div className={"setup-th"} style={{padding: padding}}>
                                        <Button variant="primary"
                                                ref={el => confirmEmailRef.current = el}
                                                onClick={() => saveSecurity()}>
                                            {t('confirm')}
                                        </Button>
                                    </div>
                                </div>
                            </>}

                            {tgtMfa === TOTP &&
                                <div className={'security-box'} style={{marginTop: '2rem'}}>
                                    <div className={'flex-nowrap'} style={{marginTop: '.3rem'}}>
                                        <div className={"setup-th"} style={{flexBasis: w100, padding: padding}}>
                                            <MdOutlinePhoneAndroid color={'#adad2f'} size={'1.8em'}
                                                                   style={{margin: '0 .5rem .5rem 0'}}/><Trans i18nKey="TOTP_setup_header" components={{header: <span className="header"/>}}/>
                                        </div>
                                    </div>

                                    <div className={'flex-nowrap'} style={{marginTop: '1rem'}}>
                                        <div className={"setup-th"} style={{flexBasis: w100, padding: padding}}>
                                            <Trans i18nKey="TOTP_setup_part1" components={{p: <p/>, header: <p className="header"/>}}/>
                                        </div>
                                    </div>
                                    <div className={'flex-nowrap'} style={{width: '100%', justifyContent: 'center'}}>
                                        {loading ? <div style={{margin: "75px auto"}}><img alt="loading" src={ajaxloader}/></div> :
                                            <div>{qrUrl && <img width={'180px'} src={qrUrl} alt="QR URL"/>}</div>
                                        }
                                    </div>
                                    <div className={'flex-nowrap'} style={{marginTop: '1rem'}}>
                                        <div className={"setup-th"} style={{flexBasis: w100, padding: padding}}>
                                            <Trans i18nKey="TOTP_setup_part2" components={{p: <p/>, header: <p className="header"/>}}/>
                                        </div>
                                    </div>
                                    <SixDigitCode
                                        onChange={(code) => changeMfaCode(code)}
                                        onComplete={(code) => validateCode(code)}
                                        disabled={loading}
                                        showValidityIcon={showValidityIcon}
                                        isValid={mfaCodeValid}
                                    />
                                    <div className={'flex-nowrap'} style={{marginTop: '1rem'}}>
                                        <div className={"setup-th"} style={{flexBasis: w100, padding: padding}}>
                                            <Trans i18nKey="TOTP_setup_part3" components={{p: <p/>, header: <p className="header"/>}}/>
                                        </div>
                                    </div>
                                    <div className={'flex-nowrap'} style={{marginTop: '1rem'}}>
                                        <div className={"setup-th"} style={{padding: padding}}>
                                            <Button variant="secondary" onClick={() => cancel2FASetup()}>
                                                {t('cancel')}
                                            </Button>
                                        </div>
                                        <div className={"setup-th"} style={{padding: padding}}>
                                            <Button variant="primary"
                                                    ref={el => confirmTotpRef.current = el}
                                                    onClick={() => saveSecurity()}
                                                    disabled={!mfaCodeValid}>
                                                {loading && (
                                                    <span className="spinner-border spinner-border-sm"/>)}
                                                {t('confirm')}
                                            </Button>
                                        </div>
                                    </div>
                                </div>}
                        </>}
                </Card.Body>
            </Card>
            <Modal
                show={showMessageModal}
                onHide={() => hideMessageModal()}
                backdrop="static"
                keyboard={false}
                size={"lg"}
                aria-labelledby="terms-and-conditions"
                scrollable={true}
            >
                <Modal.Header>
                    <Modal.Title><h3 className={'canopia'}>Authenticator setup</h3></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {errorName &&
                        <MessageBox
                            title={errorName}
                            message={errorMessage}
                            colorClass={'canopia6'}
                        />
                    }
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={() => hideMessageModal()}>
                        {t('close')}
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}
